import type { WalkInteractivityActionTreeFn } from '../interactivity/actions/utils/walkInteractivityActionTree';
import { walkInteractivityActionTree } from '../interactivity/actions/utils/walkInteractivityActionTree';
import type { ScriptConfiguration } from './types/ScriptConfiguration';
import { walkScriptConfigInteractivityActionValues } from './walkScriptConfigActionValues';

export function walkScriptConfigInteractivityActionTree(
  scriptConfig: ScriptConfiguration,
  walk: WalkInteractivityActionTreeFn,
) {
  walkScriptConfigInteractivityActionValues(scriptConfig, actionValue => {
    if (actionValue.action) {
      walkInteractivityActionTree(actionValue.action, walk);
    }
  });
}
